module.exports = __webpack_public_path__ + "img/vannkraft_paavirkning_vannfoeringsregulering.559e211b.jpg";